import { render } from "./TourListRiver.vue?vue&type=template&id=7d08a16d&scoped=true"
import script from "./TourListRiver.vue?vue&type=script&lang=js"
export * from "./TourListRiver.vue?vue&type=script&lang=js"

import "./TourListRiver.vue?vue&type=style&index=0&id=7d08a16d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d08a16d"]])

export default __exports__